<template>
  <div
    class="tab-pane resource-container active"
    role="tabpanel"
  >
    <div class="resource_overview">
      <div class="wrapper">
        <div class="chart_block">
          <div class="select-wrapper">
            <select2 :id="division_code"
                     v-model="division_code"
                     :options="division_options"
                     :settings="{ minimumResultsForSearch: -1 }"
                     @change="onChangeDivisionCode(division_code)"
            />
          </div>
          <resource-statistics :division_options="selectOptions" @on-click-pie-chart="onClickPieChart"/>
        </div>
      </div>
      <div class="wrapper">
        <div class="chart_block">
          <resource-division :division="software_development" :title="division_one_title"
                             @clicked-search-records="onClickBarChart"/>
        </div>
        <div class="chart_block">
          <resource-division :division="software_development_2" :title="division_two_title"
                             @clicked-search-records="onClickBarChart"/>
        </div>
      </div>
      <div class="wrapper">
        <div class="chart_block">
          <resource-language @on-click-language-number="onClickLanguageNumber"/>
        </div>
      </div>
      <div class="wrapper">
        <div class="chart_block">
          <resource-effort :title="effort_title"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceDivision from "./ResourceDivision";
import ResourceLanguage from "./ResourceLanguage";
import ResourceStatistics from "./ResourceStatistics";
import ResourceEffort from "./ResourceEffort";
import Select2 from 'v-select2-component';

const division_options = [
  {
    text: "Tất cả",
    id: "all",
    disabled: false,
    selected: true
  },
  {
    text: "Khối phát triển số 1",
    id: "SOFTWARE_DEVELOPMENT",
    disabled: false
  },
  {
    text: "Khối phát triển số 2",
    id: "SOFTWARE_DEVELOPMENT_2",
    disabled: false
  },
];

export default {
  name: "ResourceOverview",
  data() {
    return {
      division_one_title: "Khối phát triển số 1",
      division_two_title: "Khối phát triển số 2",
      software_development: "SOFTWARE_DEVELOPMENT",
      software_development_2: "SOFTWARE_DEVELOPMENT_2",
      division_code: 'all',
      division_options,
      search_data: null,
      select_options: {
        value: 'all',
        text: 'Thống kê toàn công ty'
      },
      effort_title: "Effort"
    }
  },
  components: {
    ResourceDivision,
    ResourceLanguage,
    ResourceStatistics,
    ResourceEffort,
    Select2
  },
  created() {
  },
  computed: {
    searchData() {
      return this.search_data;
    },
    selectOptions() {
      return this.select_options;
    }
  },
  watch: {
    'search_data': {
      handler: function (val, oldVal) {
        this.$emit('send-search-data', val);
      }
    }
  },
  methods: {
    onClickBarChart(value) {
      this.search_data = value;
    },
    onChangeDivisionCode(value) {
      this.select_options = {
        value: value,
        text: 'Thống kê ' + (value === division_options[0].id ? 'toàn công ty' : this.division_options.filter(record => record.id === value).map(record => record.text)[0].toLowerCase())
      }
    },
    onClickPieChart(value) {
      this.$emit('send-search-data', value);
    },
    onClickLanguageNumber(value) {
      this.$emit('send-search-data', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.resource-container {
  padding: 0 1rem 1rem 1rem !important;
}

.resource_overview {
  width: 100%;
  border-top: 1px solid #EFEFEF;
  padding-top: 1rem;

  .wrapper {
    width: 100%;
    display: flex;
    flex-flow: wrap;

    .chart_block {
      flex: 1 1 50%;
      width: 50%;
      padding: 10px;
    }
  }

  .select-wrapper {
    float: right;

    /deep/ .select2 {
      width: 170px !important;

      &-selection {
        border: 1px solid #CFCFCF !important;
        height: 40px !important;

        &__rendered {
          height: 100% !important;
          vertical-align: middle !important;
          display: flex !important;
          align-items: center !important;
        }

        &__arrow {
          height: 100% !important;
        }
      }
    }
  }

}

;
</style>
